import React from 'react';
import { _cs } from '@togglecorp/fujs';
import AlertContext, { DEFAULT_ALERT_DISMISS_DURATION } from '../AlertContext.js';
import Alert from '../Alert/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function AlertContainer(props) {
  const {
    className,
    children,
    maxAlerts = 5
  } = props;
  const {
    alerts,
    removeAlert
  } = React.useContext(AlertContext);
  const [numExtra, setNumExtra] = React.useState(0);
  const handleAlertCloseButtonClick = React.useCallback((name, removalDelay) => {
    setNumExtra(prev => prev + 1);
    window.setTimeout(() => {
      removeAlert(name);
      setNumExtra(prev => prev - 1);
    }, removalDelay);
  }, [removeAlert]);
  const handleAlertTimeout = React.useCallback((name, removalDelay) => {
    setNumExtra(prev => prev + 1);
    window.setTimeout(() => {
      removeAlert(name);
      setNumExtra(prev => prev - 1);
    }, removalDelay);
  }, [removeAlert]);
  const numVisibleAlerts = maxAlerts + numExtra;
  const displayAlerts = alerts.slice(0, numVisibleAlerts);
  const numHiddenAlerts = alerts.length - maxAlerts;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.alertContainer, className)
  }, displayAlerts.map(alert => /*#__PURE__*/React.createElement(Alert, {
    name: alert.name,
    className: styles.alert,
    key: alert.name,
    nonDismissable: alert.nonDismissable,
    variant: alert.variant,
    onCloseButtonClick: handleAlertCloseButtonClick,
    duration: alert.duration ?? DEFAULT_ALERT_DISMISS_DURATION,
    onTimeout: handleAlertTimeout
  }, alert.children)), numHiddenAlerts > 0 && /*#__PURE__*/React.createElement(Alert, {
    name: "$__and_n_more",
    className: styles.alert,
    nonDismissable: true,
    variant: "info",
    hideIcon: true
  }, `...and ${numHiddenAlerts} more`), children);
}

var index = genericMemo(AlertContainer);

export { index as default };
//# sourceMappingURL=index.js.map
